import { initAudioVisualizer } from './audioVisualizer.js';
import { initAcousticSimulator } from './acousticSim.js';
import { initPortfolio } from './portfolio.js';

document.addEventListener('DOMContentLoaded', () => {
  // Initialize modular features
  initAudioVisualizer();
  initAcousticSimulator();
  initPortfolio();
  initClientFilter();

  // Enforce Clean White Theme statically
  document.documentElement.setAttribute('data-theme', 'light');

  // Mobile Menu Toggle
  const mobileMenuBtn = document.getElementById('mobileMenuBtn');
  const navLinks = document.getElementById('navLinks');

  if (mobileMenuBtn && navLinks) {
    mobileMenuBtn.addEventListener('click', () => {
      navLinks.classList.toggle('active');
      const isExpanded = navLinks.classList.contains('active');
      mobileMenuBtn.setAttribute('aria-expanded', isExpanded);
    });

    // Close menu when clicking link
    document.querySelectorAll('.nav-link').forEach(link => {
      link.addEventListener('click', () => {
        navLinks.classList.remove('active');
      });
    });
  }

  // Animated Stat Counter
  const statNumbers = document.querySelectorAll('.stat-number');
  let animated = false;

  function runCounters() {
    statNumbers.forEach(stat => {
      const target = parseInt(stat.getAttribute('data-target') || '0', 10);
      const suffix = stat.getAttribute('data-suffix') || '';
      let count = 0;
      const speed = Math.max(1, Math.ceil(target / 40));

      const timer = setInterval(() => {
        count += speed;
        if (count >= target) {
          stat.textContent = target + suffix;
          clearInterval(timer);
        } else {
          stat.textContent = count + suffix;
        }
      }, 30);
    });
  }

  // Trigger counters when scrolled into view
  const heroStats = document.querySelector('.hero-stats');
  if (heroStats) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !animated) {
          animated = true;
          runCounters();
        }
      });
    }, { threshold: 0.5 });

    observer.observe(heroStats);
  }

  // Client Search & Category Filter Logic
  function initClientFilter() {
    const searchInput = document.getElementById('clientSearchInput');
    const filterBtns = document.querySelectorAll('#clientCategoryFilter .filter-btn');
    const clientCards = document.querySelectorAll('#clientsGrid .client-logo-card');

    if (!searchInput || !clientCards.length) return;

    let activeCategory = 'all';
    let searchQuery = '';

    function filterClients() {
      clientCards.forEach(card => {
        const cat = card.getAttribute('data-client-cat');
        const text = card.textContent.toLowerCase();

        const matchesCat = (activeCategory === 'all' || activeCategory === cat);
        const matchesQuery = (!searchQuery || text.includes(searchQuery));

        if (matchesCat && matchesQuery) {
          card.style.display = 'flex';
          card.style.opacity = '1';
        } else {
          card.style.display = 'none';
          card.style.opacity = '0';
        }
      });
    }

    // Search input listener
    searchInput.addEventListener('input', (e) => {
      searchQuery = e.target.value.toLowerCase().trim();
      filterClients();
    });

    // Category button listener
    filterBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        filterBtns.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');

        activeCategory = btn.getAttribute('data-client-cat');
        filterClients();
      });
    });
  }

  // Contact Form Submission
  const contactForm = document.getElementById('contactForm');
  const formSuccess = document.getElementById('formSuccess');

  if (contactForm) {
    contactForm.addEventListener('submit', (e) => {
      e.preventDefault();
      
      const btn = contactForm.querySelector('button[type="submit"]');
      const origText = btn.innerHTML;
      btn.disabled = true;
      btn.innerHTML = `<span>Sending Inquiry...</span>`;

      setTimeout(() => {
        contactForm.reset();
        btn.disabled = false;
        btn.innerHTML = origText;
        if (formSuccess) {
          formSuccess.style.display = 'block';
          setTimeout(() => {
            formSuccess.style.display = 'none';
          }, 5000);
        }
      }, 1000);
    });
  }
});
